<template>
  <div class="manage-banner">
    <el-row type="flex" align="middle" justify="space-between" class="mb-l">
      <el-row type="flex" align="middle" class="page-title">
        <i class="el-icon-menu mr-s" />
        <h3>Quản lý Banner</h3>
      </el-row>
      <router-link :to="{ name: 'CreateBanner' }">
        <el-button type="primary"> Thêm </el-button>
      </router-link>
    </el-row>
    <el-row type="flex" justify="end">
      <el-button
        size="medium"
        type="primary"
        class="mb-m"
        @click="handleRefreshData"
      >
        <i class="el-icon-refresh"></i>
      </el-button>
    </el-row>
    <el-table :data="banners" border v-loading="callingAPI">
      <el-table-column label="#" type="index" align="center" width="50px" />
      <el-table-column label="Title">
        <template slot-scope="scope"> {{ scope.row.title }} </template>
      </el-table-column>
      <el-table-column label="Nội dung">
        <template slot-scope="scope"> {{ scope.row.description }} </template>
      </el-table-column>
      <el-table-column label="Keywords">
        <template slot-scope="scope"> {{ scope.row.keyword }} </template>
      </el-table-column>
      <el-table-column label="Hình ảnh" width="120px">
        <template slot-scope="scope">
          <img
            v-if="scope.row.image"
            :src="scope.row.image"
            alt=""
            class="image-avatar-banner"
          />
          <span v-else>No data</span>
        </template>
      </el-table-column>
      <el-table-column label="Hiển thị" align="center" width="80px">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            @change="handleUpdate(scope.row)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="Sửa" align="center" width="70px">
        <template slot-scope="scope">
          <router-link
            :to="{ name: 'UpdateBanner', params: { id: scope.row.id } }"
          >
            <el-button type="primary" size="small" icon="el-icon-edit" circle />
          </router-link>
        </template>
      </el-table-column>
      <el-table-column label="Xoá" align="center" width="70px">
        <template slot-scope="scope">
          <el-button
            type="danger"
            size="small"
            @click="handeRemove(scope.row)"
            icon="el-icon-delete"
            circle
          />
        </template>
      </el-table-column>
    </el-table>
    <el-row type="flex" justify="end" class="mt-m">
      <el-pagination
        background
        layout="prev, pager, next"
        :disabled="callingAPI"
        @current-change="handleChangePage"
        :currentPage="page"
        :pageSize="pageSize"
        :total="total"
      />
    </el-row>
  </div>
</template>

<script>
import { fetchBanner, deleteBanner, updateBanner } from "@/services/banner";
import { replaceUrlResourceBlog } from "@/utils/common";
export default {
  name: "ManageBanner",
  data() {
    return {
      callingAPI: false,
      debounce: null,

      banners: [],

      page: 1,
      pageSize: 10,
      total: 0,
    };
  },
  async beforeMount() {
    await this.loadData();
  },
  methods: {
    async handleRefreshData() {
      await this.loadData(this.page);
    },

    async loadData(page = null) {
      try {
        this.callingAPI = true;
        const params = {
          page: page ? page : 1,
          per_page: this.pageSize,
        };
        const response = await fetchBanner(params);
        this.banners = response.data.data.map((b) => ({
          ...b,
          status: b.status == 1 ? true : false,
          image: replaceUrlResourceBlog(b.image),
        }));
        this.total = response.data.total;
        this.callingAPI = false;
      } catch (error) {
        this.callingAPI = false;
      }
    },

    async handleSearchAdvise() {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(async () => {
        await this.loadData();
      }, 500);
    },

    async handleChangePage(page) {
      this.page = page;
      await this.loadData(page);
    },

    async handleUpdate(row) {
      try {
        this.callingAPI = true;
        const data = {
          status: row.status ? 1 : 2,
          _method: "PUT",
        };
        const response = await updateBanner(row.id, data);
        if (response.status === 0) {
          this.callingAPI = false;
          this.$notify.error({
            title: "Thất bại",
            message: response.message,
            duration: 2000,
          });
          return;
        }
        await this.loadData(this.page);
        this.$notify.success({
          title: "Thành công",
          message: `Cập nhật thành công.`,
          duration: 2000,
        });
      } catch (error) {
        this.callingAPI = false;
        this.$notify.error({
          title: "Thất bại",
          message: "Cập nhật thất bại.",
          duration: 2000,
        });
      }
    },

    async handeRemove(row) {
      this.$confirm(`Chắc chắn muốn xoá ?`, "Warning", {
        confirmButtonText: "Xoá",
        cancelButtonText: "Huỷ",
        type: "warning",
      })
        .then(async () => {
          try {
            this.callingAPI = true;
            const data = {
              _method: "DELETE",
            };
            const response = await deleteBanner(row.id, data);
            if (response.status === 0) {
              this.callingAPI = false;
              this.$notify.error({
                title: "Thất bại",
                message: response.message,
                duration: 2000,
              });
              return;
            }
            await this.loadData(this.page);
            this.$notify.success({
              title: "Thành công",
              message: `Xoá thành công.`,
              duration: 2000,
            });
          } catch (error) {
            this.callingAPI = false;
            this.$notify.error({
              title: "Thất bại",
              message: "Xoá thất bại.",
              duration: 2000,
            });
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.manage-banner {
  .image-avatar-banner {
    width: 100%;
    object-fit: cover;
  }
}
.el-form-item {
  margin-bottom: 0;
}
</style>
